import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import ArchivContainer from "../../utils/ArchivContainer";
import StaticFunctions from "../../utils/StaticFunctions";
import DesignPreviewContainer from "../../utils/DesignPreviewContainer";

class DesignSmall extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        data: PropTypes.array.isRequired,
        onClick: PropTypes.func.isRequired
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {};

        this.translate = this.props.baseData.translate;

    }

    componentWillMount() {

        if (this.props.willMount) this.props.willMount();

    }

    getItems() {

        const items = [];

        this.props.data.forEach((item) => {
            if (item !== null) {
                items.push(<ArchivContainer
                    key={'design-small-' + item.id + '-' + item.stitches}
                    archivKey={'small-design'}
                    archivId={item.id}
                    classes={'bordered bgContain bgWhite col-lg-2'}
                    content={<DesignPreviewContainer baseData={this.props.baseData} designId={item.id} designStitches={item.stitches}/>}
                    onClick={this.props.onClick}
                />);
            }
        });

        if (items.length > 0) return items;

        return this.translate('noDesignFound');

    }

    render() {

        return this.getItems();

    }

}

export default DesignSmall;